import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import * as empresasApi from '../api/empresas';
import { EMPRESA_STORAGE_KEY, MODO_GLOBAL } from '../utils/storageKeys';
import { useAuth } from './AuthContext';

const EmpresaContext = createContext(null);

export function EmpresaProvider({ children }) {
  const { user, loading: authLoading } = useAuth();
  const isSuperAdmin = user?.perfil === 'super_admin';

  const [empresas, setEmpresas] = useState([]);
  const [idEmpresa, setIdEmpresaState] = useState(() => localStorage.getItem(EMPRESA_STORAGE_KEY) || '');
  const [loading, setLoading] = useState(false);

  const modoGlobal = idEmpresa === MODO_GLOBAL;
  const empresaAtual = empresas.find((e) => e.id_empresa === idEmpresa) || null;

  const setIdEmpresa = useCallback((id) => {
    setIdEmpresaState(id);
    if (id) localStorage.setItem(EMPRESA_STORAGE_KEY, id);
    else localStorage.removeItem(EMPRESA_STORAGE_KEY);
  }, []);

  useEffect(() => {
    // enquanto o AuthContext ainda não resolveu quem é o usuário, `user` é null e
    // isSuperAdmin dá falso-negativo — esperar aqui evita apagar a seleção salva (inclusive
    // o modo Global) antes mesmo de saber se quem está logando é super_admin ou não.
    if (authLoading) return;
    if (!isSuperAdmin) {
      setEmpresas([]);
      setIdEmpresa('');
      return;
    }
    setLoading(true);
    empresasApi
      .listEmpresas()
      .then((r) => {
        setEmpresas(r.data);
        const atual = localStorage.getItem(EMPRESA_STORAGE_KEY);
        const aindaValida = atual === MODO_GLOBAL || r.data.some((e) => e.id_empresa === atual);
        if (!aindaValida) setIdEmpresa(r.data[0]?.id_empresa || '');
      })
      .catch(() => setEmpresas([]))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuperAdmin, authLoading]);

  return (
    <EmpresaContext.Provider
      value={{ isSuperAdmin, empresas, idEmpresa, setIdEmpresa, loading, modoGlobal, empresaAtual }}
    >
      {children}
    </EmpresaContext.Provider>
  );
}

export function useEmpresaSelecionada() {
  return useContext(EmpresaContext);
}
